import { render } from "./escolaAll.vue?vue&type=template&id=8bfce6f6&scoped=true"
import script from "./escolaAll.vue?vue&type=script&lang=js"
export * from "./escolaAll.vue?vue&type=script&lang=js"

import "./escolaAll.vue?vue&type=style&index=0&id=8bfce6f6&lang=scss&scoped=true"
import "./escolaAll.vue?vue&type=style&index=1&id=8bfce6f6&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bfce6f6"]])

export default __exports__